<template>
  <a
    v-if="conversationId"
    class="button is-small offer-conversation-btn"
    title="צפה בשיחה שהתקיימה עם המועמד על ההצעה"
    @click="openChatbotPanel"
  >
    שיחה
  </a>
</template>
<script>
export default {
  name: 'offer-conversation-button',
  props: ['payload'],
  computed: {
    applicantId () {
      const a = this.payload && this.payload.applicant
      return a ? (a.resource_id || a.id) : null
    },
    positionId () {
      return this.payload && this.payload.position && this.payload.position.id
    },
    conversationId () {
      if (!this.payload) return null
      return this.$store.getters['offerConversations/getConvId'](
        this.applicantId, this.payload.id, this.positionId
      )
    }
  },
  mounted () {
    if (this.applicantId) {
      this.$store.dispatch('offerConversations/fetchForApplicant', {
        applicantId: this.applicantId,
        vm: this
      })
    }
  },
  methods: {
    openChatbotPanel () {
      const convId = this.conversationId
      if (!convId) return
      const base = 'https://chatbot.test.panel.hasama.online'
      // The operation slug tells the readonly panel which tenant API to query.
      const slug = this.$settings.get({ path: 'intake_operation_slug' })
      let url = `${base}?conversation_id=${convId}&readonly=true`
      if (this.applicantId) url += `&applicant_id=${this.applicantId}`
      if (slug) url += `&operation=${slug}`
      window.open(url, '_blank')
    }
  }
}
</script>
<style scoped>
.offer-conversation-btn {
  background-color: #3273dc;
  color: white;
  border-color: #3273dc;
  font-size: 0.7rem;
  white-space: nowrap;
}
.offer-conversation-btn:hover {
  background-color: #2366d1;
  color: white;
}
</style>
